import "devextreme/ui/select_box";
import "devextreme/ui/check_box";
import "devextreme/ui/number_box";
import "devextreme/ui/text_box";
import "devextreme/ui/date_box";
import "devextreme/ui/tag_box";
import "devextreme/ui/text_area";

import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.tsx";
import "devextreme/dist/css/dx.light.css";
import "./index.css";
import config from "devextreme/core/config";
import { licenseKey } from "./devextreme-license";
import "@fontsource/dm-sans/400.css"; // Specify weight
import "@fontsource/dm-sans/400-italic.css";
config({ licenseKey });

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
